export const REGISTRATION_STATUSES = {
  REGISTERED: 'registered',
  INVITED: 'invited',
};
